module.exports = __webpack_public_path__ + "media/images/flags/1x1/uzb-0d470cd112db5215eab06a31c5523df3.svg";